export default "__VITE_PUBLIC_ASSET__d0f61062__"